module.exports = __webpack_public_path__ + "img/hx-rkgl.7cb8f0c4.svg";